import { OfferOptionTypeDto } from 'src/dtos';

export const offerOptions = [
  { id: OfferOptionTypeDto.STATUS, name: 'Offer Status' },
  { id: OfferOptionTypeDto.OFFER_TYPE, name: 'Offer Type' },
  { id: OfferOptionTypeDto.INDUSTRY, name: 'Offer Industry' },
  { id: OfferOptionTypeDto.CATEGORY, name: 'Offer Category' },
  { id: OfferOptionTypeDto.SECURITY_TYPE, name: 'Offer Security Type' },
];
